<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>计划详情</h4>
      <div @click="backClick"><i class="fa fa-reply"></i></div>
    </div>
    <div class="topRadio" v-if="rowsData.weightFlg == 'T'">
      显示方式：
      <!-- <el-radio v-model="radio" label="1">按订单汇总</el-radio>
      <el-radio v-model="radio" label="2">按合同汇总</el-radio> -->
      <el-radio-group v-model="radio" @change="radioChange">
        <el-radio label="1">按订单汇总</el-radio>
        <el-radio label="2">按合同汇总</el-radio>
      </el-radio-group>
    </div>
    <!-- 按合同号汇总 -->
    <div v-if="radio == '2' && rowsData.weightFlg == 'T'">
      <div class="searchBox" ref="searchBox">
        <el-button type="primary"  btnCode='00DP001B00W' v-if="btnFlg[5]" @click="jiGangFinish">完成</el-button>
        <el-button type="primary"  btnCode='00DP001B00X' v-if="btnFlg[6]" @click="jiGangUnFinish">撤销完成</el-button>
      </div>
      <div class="tongJi" style="margin-top:10px;">
        <div class="tongJi_item">
          计划量：<span>{{heTongPlan}}</span>&nbsp;&nbsp;吨
        </div>
        <div class="tongJi_item">
          出货量：<span>{{heTongChuHuo}}</span>&nbsp;&nbsp;吨
        </div>
        <div class="tongJi_item">
          未完成：<span>{{(heTongPlan - heTongChuHuo).toFixed(3)}}</span>&nbsp;&nbsp;吨
        </div>
        <div class="tongJi_item">
          可装配：<span>{{heTongKeZhuangPei}}</span>&nbsp;&nbsp;吨
        </div>
      </div>
      <div class=""  v-loading='contractNoTabLoading'>
        <el-table
          :data="contractNoTableList"
          ref="contractNoTableList"
          border
          bordersize="mini"
          height="400"
          style="width: 100%;margin-top:10px;"
          center
          @row-click = 'secondHandleRowClick'
          :header-cell-style="{background:'#F5F5F5',color:'black'}"
          :header-row-style="{height:'45px'}"
          :row-style="{height:'35px'}"
          highlight-current-row>
          <el-table-column  type="index" prop="" width="55" label="序号" align="center"></el-table-column>
          <el-table-column prop="" label="合同号" align="center" width="200" :formatter="emptyFn">
            <template slot-scope="scope"><div>
              <span v-if="scope.row.contractNo == '' || scope.row.contractNo == undefined || scope.row.contractNo == null">-</span>
              <span v-else>{{scope.row.contractNo}}</span>
            </div></template>
          </el-table-column>
          <el-table-column prop="" label="已开交货" align="center" >
            <template slot-scope="scope"><div>
              <span v-if="scope.row.canpayWeight == '' || scope.row.canpayWeight == undefined || scope.row.canpayWeight == null">-</span>
              <span v-else>{{scope.row.canpayWeight}}</span>
            </div></template>
          </el-table-column>
          <el-table-column prop="" label="出货量" align="center" :formatter="emptyFn">
            <template slot-scope="scope"><div>
              <el-button @click="jiGangHeTongChuHuo(scope.row)" type="text" size="small">{{scope.row.realdeliWeight}}</el-button>
            </div></template>
          </el-table-column>
          <!-- 计划量-装配量 = 未完成 -->
          <el-table-column prop="suplusWeight" label="未完成" align="center"></el-table-column>
          <el-table-column prop="" label="预出库"  align="center" :formatter="emptyFn">
            <template slot-scope="scope"><div>
              <span v-if="scope.row.loadWeight == '' || scope.row.loadWeight == undefined || scope.row.loadWeight == null">-</span>
              <span v-else>{{scope.row.loadWeight}}</span>
            </div></template>
          </el-table-column>
          <el-table-column prop="inventoryWeight" label="可发库存" align="center" :formatter="emptyFn"></el-table-column>
          <el-table-column prop="topWeight" label="可装配"  align="center" :formatter="emptyFn"></el-table-column>
          <el-table-column prop="" label="状态"  align="center">
             <template slot-scope="scope"><div>
              <span v-if="scope.row.planStatus == '1'">未完成</span>
              <span v-if="scope.row.planStatus == '2'">已完成</span>
            </div></template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center">
            <template slot-scope="scope"><div>
              <span>{{scope.row.createTime | dateFormat}}</span>
            </div></template>
          </el-table-column>
          <el-table-column prop="" label="完成时间" align="center" width="140" :formatter="emptyFn">
            <template slot-scope="scope"><div>
            <span>{{scope.row.finishTime | dateFormat}}</span>
          </div></template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--按订单-->
    <div v-if="radio == '1'">
      <div class="searchBox" ref="searchBox">
        <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
          <div class=" inpBox">
            <el-form-item label="订单:" prop="orderItem">
              <el-input  placeholder="" maxlength="100" v-model="orderItem"></el-input>
            </el-form-item>
            <el-form-item label="合同号:" prop="contractNo" v-if="rowsData.weightFlg == 'T'">
              <el-input  placeholder="" maxlength="100" v-model="contractNo"></el-input>
            </el-form-item>
          </div>
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" @click="searchClick" btnCode='00DP001B00T' v-if="btnFlg[2]">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chongZhiClick" btnCode='00DP001B00U' v-if="btnFlg[3]" >重置</el-button>
          </el-form-item>
        </div>
        </el-form>
      </div>
      <div class="tongJi">
        <div class="tongJi_item">
          已开交货：<span>{{dingDanJiaoHuo}}</span>&nbsp;&nbsp;吨
        </div>
        <div class="tongJi_item">
          出货量：<span>{{dingDanChuHuo}}</span>&nbsp;&nbsp;吨
        </div>
        <div class="tongJi_item">
          未完成：<span>{{(dingDanJiaoHuo - dingDanChuHuo).toFixed(3)}}</span>&nbsp;&nbsp;吨
        </div>
      </div>
      <div class="table" :style="{height:h}" v-loading='tabLoading'>
        <el-table
          :data="tableList"
          ref="tableList"
          border
          bordersize="mini"
          height="91%"
          style="width: 100%;margin-top:10px;"
          center
          :header-cell-style="{background:'#F5F5F5',color:'black'}"
          :header-row-style="{height:'45px'}"
          :row-style="{height:'35px'}"
          highlight-current-row>
          <el-table-column  type="index" prop="" width="55" label="序号" align="center"></el-table-column>
          <el-table-column type="index" prop="" width="80" label="操作" align="center">
            <template slot-scope="scope"><div> 
              <el-button @click="deliveryNoteClick(scope.row)" type="text" size="small" btnCode='00DP001B00V' v-if="btnFlg[4]">交货单</el-button>
            </div></template>
          </el-table-column>
          <el-table-column prop="orderItemNo" label="订单号项次号" align="center" width="180" :formatter="emptyFn">
             <template slot-scope="scope"><div> 
              <span v-if="scope.row.orderItemNo == '' || scope.row.orderItemNo == undefined || scope.row.orderItemNo == null">-</span>
              <span v-else>{{scope.row.orderItemNo}}</span>
            </div></template>
          </el-table-column>
          <el-table-column prop="" label="合同号" align="center" width="150" :formatter="emptyFn">
            <template slot-scope="scope"><div> 
              <span v-if="scope.row.contractNo == '' || scope.row.contractNo == undefined || scope.row.contractNo == null">-</span>
              <span v-else>{{scope.row.contractNo}}</span>
            </div></template>
          </el-table-column>
          <el-table-column prop="" label="已开交货" align="center" >
            <template slot-scope="scope"><div> 
              <span v-if="scope.row.canpayWeight == '' || scope.row.canpayWeight == undefined || scope.row.canpayWeight == null">-</span>
              <span v-else>{{scope.row.canpayWeight}}</span>
            </div></template>
          </el-table-column>
          <el-table-column prop="realdeliWeight" label="出货量" align="center" :formatter="emptyFn">
            <template slot-scope="scope"><div> 
              <el-button @click="shipmentClick(scope.row)" type="text" size="small">{{scope.row.realdeliWeight}}</el-button>
            </div></template>
          </el-table-column>
          <el-table-column prop="surplusWeight" label="未完成" align="center" :formatter="emptyFn"></el-table-column>
          <el-table-column prop="availableDeliverWeight" label="可发量" align="center" :formatter="emptyFn"></el-table-column>
          <el-table-column prop="loadWeight" label="预出库" align="center" :formatter="emptyFn">
            <template slot-scope="scope"><div> 
              <span v-if="scope.row.loadWeight == '' || scope.row.loadWeight == undefined || scope.row.loadWeight == null">-</span>
              <span v-else>{{scope.row.loadWeight}}</span>
            </div></template>
          </el-table-column>
          <el-table-column prop="inventoryWeight" label="库存" align="center" :formatter="emptyFn">
            <template slot-scope="scope"><div> 
              <span v-if="scope.row.inventoryWeight == '' || scope.row.inventoryWeight == undefined || scope.row.inventoryWeight == null">-</span>
              <span v-else>{{scope.row.inventoryWeight}}</span>
            </div></template>
          </el-table-column>
          <el-table-column prop="topWeight" label="可装配" align="center" :formatter="emptyFn">
            <template slot-scope="scope"><div> 
              <span v-if="scope.row.topWeight == '' || scope.row.topWeight == undefined || scope.row.topWeight == null">-</span>
              <span v-else>{{scope.row.topWeight}}</span>
            </div></template>
          </el-table-column>
          <el-table-column prop="goodsName" label="产品名称" align="center" :formatter="emptyFn"></el-table-column>
          <el-table-column prop="goodsSpec" label="尺寸规格" align="center" :formatter="emptyFn"></el-table-column>
          <el-table-column prop="goodsType" label="牌号" align="center" :formatter="emptyFn"></el-table-column>
        </el-table>
      </div>
      <!-- 分页 10,25,50,100-->
      <div >
        <el-pagination background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[10,25,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total1">
        </el-pagination>
      </div>
    </div>
    <!-- 交货单弹出框 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="deliveryNoteMark"
    @close="closeDialog"
    width="1200px"
    center>
      <span>
        <div class="addinpBox">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span>合同号：</span>
                <span>{{deliveryNoteContractNo}}</span>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span>订单项次号：</span>
                <span>{{deliveryNoteOrder}}</span>
                <el-table
                  :data="deliveryNoteTableList"
                  ref="deliveryNoteTableList"
                  border
                  bordersize="mini"
                  style="width:95%;margin-top:10px;margin-left:3%;margin-bottom:17px"
                  center
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                  :header-row-style="{height:'35px'}"
                  :row-style="{height:'25px'}"
                  highlight-current-row>
                  <el-table-column type="index" prop="" width="55" label="序号" align="center" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="deliverItemNo" label="交货单号" width="150" align="center" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="canpayWeight" label="计划量" align="center" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="realdeliWeight" label="出货量"  align="center" :formatter="emptyFn" ></el-table-column>
                  <el-table-column prop="surplusWeight" label="未完成" align="center" :formatter="emptyFn" v-if="surplusWeight ='生效'">
                    <!-- <template slot-scope="scope"><div> 
                      <span v-if="scope.row.deliveryStatusShow == '生效'">{{scope.row.surplusWeight}}</span>
                      <span v-else-if="scope.row.deliveryStatusShow == '关闭' || scope.row.surplusWeight == null || scope.row.surplusWeight == undefined || scope.row.surplusWeight == ''">-</span>
                    </template> -->
                  </el-table-column>
                  <el-table-column prop="surplusWeight" label="可发量" align="center" :formatter="emptyFn">
                    <template slot-scope="scope"><div> 
                      <span v-if="scope.row.deliveryStatusShow == '生效'">{{scope.row.surplusWeight }}</span>
                      <span v-else>0</span>
                    </div></template>
                  </el-table-column>
                  <el-table-column prop="deliveryStatusShow" label="状态" align="center" :formatter="emptyFn" ></el-table-column>
                  <el-table-column prop="createTime" label="创建时间" width="180" align="center" :formatter="emptyFn">
                    <template slot-scope="scope"><div>
                      <span>{{scope.row.createTime | dateFormat}}</span>
                    </div></template>
                  </el-table-column>
                  <el-table-column prop="effectTime" label="生效时间" width="180" align="center" :formatter="emptyFn">
                    <template slot-scope="scope"><div>
                      <span>{{scope.row.effectTime | dateFormat}}</span>
                    </div></template>
                  </el-table-column>
                  <el-table-column prop="closeTime" label="关闭时间" width="180" align="center" :formatter="emptyFn" >
                    <template slot-scope="scope"><div>
                      <span>{{scope.row.closeTime | dateFormat}}</span>
                    </div></template>
                  </el-table-column>
                </el-table>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deliveryNoteMark=false" size='mini'>关闭</el-button>
      </span>
    </el-dialog>
    <!-- 出货详情弹出框 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="shipmentMark"
    @close="closeDialog"
    width="1200px"
    center>
      <span>
        <div class="addinpBox">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span>合同号：</span>
                <span>{{shipmentContractNo}}</span>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span v-if="radio == '1'">订单项次号：</span>
                <span v-if="radio == '1'">{{shipmentOrder}}</span>
                <el-table
                  :data="shipmentTableList"
                  ref="shipmentTableList"
                  border
                  bordersize="mini"
                  style="width:95%;margin-top:10px;margin-left:3%;margin-bottom:17px"
                  center
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                  :header-row-style="{height:'35px'}"
                  :row-style="{height:'25px'}"
                  highlight-current-row>
                  <el-table-column  type="index" prop="" width="55" label="序号" align="center" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="plateId" label="板序号" align="center"  :formatter="emptyFn"></el-table-column>
                  <el-table-column v-if="radio == '1'" prop="deliverItemNo" label="交货单号" align="center"  :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="vehicelNo" label="车牌号"  align="center" :formatter="emptyFn" ></el-table-column>
                  <el-table-column prop="theoryWeitht" label="理重" align="center"  :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="actualWeitht" label="实重" align="center"  :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="loadNo" label="装车单号"  align="center" :formatter="emptyFn" ></el-table-column>
                  <el-table-column prop="waybillNo" label="运单号" align="center" width="220" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="outDate"  label="出库时间" align="center"  :formatter="emptyFn"></el-table-column>
                </el-table>
                <!-- 分页 10,25,50,100-->
                <div style="margin-left:28px;">
                  <el-pagination background
                    @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                    :current-page="pageNo2"
                    :page-sizes="[10,25,50,100]"
                    :page-size="pageSize2"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total2">
                  </el-pagination>
                </div>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shipmentMark=false" size='mini'>关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  detailList,// 列表
  deliverList, // 交货单
  loadDetailList,// 出货量
  baseContract, // 按合同汇总
  planComplete,  // 计划完成/未完成
  statisticsPlanDetail,  // 已开交货统计
  loadDetailListByContract // 集港合同汇总-出货量
} from '@/api/zhb'
import { getBtn } from '@/utils/getButton'
import { encryption, emptyFn } from '@/utils/util'
import DonMessage from '@/utils/message'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      // 按钮
      btnFlg: [],
      btnIdArr: ['00DP001B001', '00DP001B002','00DP001B00T','00DP001B00U','00DP001B00V',
                '00DP001B00W','00DP001B00X'],
      activeName: 'first',
      dingDanJiaoHuo: 0,
      dingDanChuHuo: 0,
      faHuoLiang: 0,
      wanChengLv: 0,
      title: '',
      h: '500px',
      searchFrom:{},
      pageNo: 1,
      pageSize: 10,
      total1: 0,
      pageNo2: 1,
      pageSize2: 10,
      total2: 0,
      orderItem:'',
      value: '',
      tableList: [],
      tabLoading:false,
      deliveryNoteMark:false,
      deliveryNoteContractNo:'',
      deliveryNoteOrder:'',
      deliveryNoteTableList:[],
      shipmentMark:false,
      shipmentOrder:'',
      shipmentContractNo:'',
      shipmentTableList:[],
      radio: '1',
      contractNoTableList:[],
      contractNoTabLoading:false,
      rowsData:{},
      rowSelected:{},
      heTongPlan:'',
      heTongKeZhuangPei:'',
      heTongChuHuo:'',
      contractNo:'',
      weightFlg:''
    }
  },
  created () {
    this.rowsData = JSON.parse(localStorage.getItem('rowData'))
    if(this.rowsData.weightFlg == 'A'){
      this.radio = '1'
      this.getOrderData()
      this.waiFaStatisticsPlanDetail2()
    }else{
      this.radio = '2'
      this.getBaseContractData()
      this.heTongStatisticsPlanDetail()
    }
    // if(this.radio == '1'){
    //   this.getOrderData()
    //   this.waiFaStatisticsPlanDetail2()
    // }else{
    //   this.getBaseContractData()
    //   this.heTongStatisticsPlanDetail()
    // }
    this.btnFlg = getBtn(this.btnIdArr, '/planManagement')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 150) + 'px'
  },
  methods: {
    //日期格式化
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 单选框改变事件
    radioChange(){
      if(this.radio == '1'){
        this.getOrderData()
        this.waiFaStatisticsPlanDetail2()
      }else{
        this.getBaseContractData()
        this.heTongStatisticsPlanDetail()
      }
    },
    // 集港查询-按订单
    getOrderData () {
      this.tabLoading = true
      detailList({
        ids:this.rowsData.ids,
        orderItem:this.orderItem,
        pageNo: this.pageNo,
        pageSize:this.pageSize,
        contractNo:this.contractNo
      }).then(res => {
        this.tabLoading = false
        this.tableList = res.list
        this.total1 = res.total
      }).catch(err => {
        this.tabLoading = false
        this.$message.error(err.message)
      })
    },
    // 订单已开交货统计
    waiFaStatisticsPlanDetail2(){
      statisticsPlanDetail({
        ids:this.rowsData.ids,
        orderItem:this.orderItem,
        pageNo: this.pageNo,
        pageSize:this.pageSize,
        contractNo:this.contractNo
      }).then(res => {
        if(res !== null){
          this.dingDanJiaoHuo = res.canpayWeight
          this.dingDanChuHuo = res.loadWeight
        }else{
          this.dingDanJiaoHuo = 0
          this.dingDanChuHuo = 0
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 集港查询-按合同
    getBaseContractData(){
      this.contractNoTabLoading = true
      this.contractNoTableList = []
      baseContract({
        planIds:this.rowsData.ids
      }).then(res => {
        this.contractNoTabLoading = false
        this.contractNoTableList = res.list
        this.heTongKeZhuangPei = res.totalTopWeight
      }).catch(err => {
        this.contractNoTabLoading = false
        this.$message.error(err.message)
      })
    },
    // 合同已开交货统计
    heTongStatisticsPlanDetail(){
      statisticsPlanDetail({
        ids:this.rowsData.ids
      }).then(res => {
        this.heTongPlan = res.canpayWeight
        this.heTongChuHuo = res.loadWeight
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击按订单查询按钮
    searchClick () {
      this.getOrderData()
      this.waiFaStatisticsPlanDetail2()
    },
    // 点击重置
    chongZhiClick () {
      this.orderItem = ''
      this.contractNo = ''
      this.pageNo =  1
      this.pageSize = 10
      this.getOrderData()
      this.waiFaStatisticsPlanDetail2()
    },
    // 每页条数
    handleSizeChange (val) {
      this.pageSize = val
      this.getOrderData()
    },
    // 当前页
    handleCurrentChange (val) {
      this.pageNo = val
      this.getOrderData()
    },
    // 返回
    backClick () {
      this.$router.go(-1)
    },
    // 点击交货单
    deliveryNoteClick(row){
      this.deliveryNoteMark = true
      this.title = '交货单'
      this.deliveryNoteContractNo = row.contractNo
      this.deliveryNoteOrder = row.orderItemNo
      deliverList(row.ids).then(res => {
        this.deliveryNoteTableList = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击出货量
    shipmentClick(row){
      this.shipmentMark = true
      this.title = '出货详情'
      this.shipmentContractNo = row.contractNo
      this.shipmentOrder = row.orderItemNo
      this.weightFlg = row.weightFlg
      this.getLoadDetailList()
    },
    getLoadDetailList(){
       loadDetailList({
        orderItemNo:this.shipmentOrder,
        contractNo:this.shipmentContractNo,
        pageNo:this.pageNo2,
        pageSize:this.pageSize2,
        weightFlg: this.weightFlg
      }).then(res => {
        this.shipmentTableList = res.list
        this.total2 = res.total
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange2 (val) {
      this.pageSize2 = val
      this.getLoadDetailList()
    },
    // 当前页
    handleCurrentChange2 (val) {
      this.pageNo2 = val
      this.getLoadDetailList()
    },
    closeDialog () {
      this.$emit('destroy')
    },
    // 按合同
    secondHandleRowClick(row){
      this.rowSelected=row
      this.$refs.contractNoTableList.toggleRowSelection(row)
    },
    // 点击集港完成
    jiGangFinish(){
      if (this.rowSelected.contractNo==null||this.rowSelected.contractNo==undefined||this.rowSelected.contractNo=='') {
        this.$message.error("请选择一条数据进行操作")
      }else if(this.rowSelected.planStatus == '2'){
        this.$message.error("已完成的合同不可操作！")
      } else{
        this.$confirm('计划完成后不可派车，请确认是否完成？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          planComplete({
            id:this.rowSelected.id,
            planStatus: 2
          })
            .then(res => {
              DonMessage.success('操作成功!')
              this.getBaseContractData()
            })
            .catch(err => {
              DonMessage.error(err.message)
            })
        })
        .catch(() => {})
      }
    },
    // 点击撤销完成
    jiGangUnFinish(){
      if (this.rowSelected.contractNo==null||this.rowSelected.contractNo==undefined||this.rowSelected.contractNo=='') {
        this.$message.error("请选择一条数据进行操作")
      }else if(this.rowSelected.planStatus == '1'){
        this.$message.error("未完成的合同不可操作！")
      } else{
        this.$confirm('是否确定此操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          planComplete({
            id:this.rowSelected.id,
            planStatus: 1
          })
            .then(res => {
              DonMessage.success('操作成功!')
              this.getBaseContractData()
            })
            .catch(err => {
              DonMessage.error(err.message)
            })
        })
        .catch(() => {})
      }
    },
    //集港合同汇总-出货量   
    jiGangHeTongChuHuo(row){
      this.shipmentMark = true
      this.title = '出货详情'
      this.shipmentContractNo = row.contractNo
      loadDetailListByContract({
        contractNo:row.contractNo,
        weightFlg: row.weightFlg,
        pageNo:this.pageNo2,
        pageSize:this.pageSize2
      })
      .then(res => {
        this.shipmentTableList = res.list
        this.total2 = res.total
      })
      .catch(err => {
        DonMessage.error(err.message)
      })
    }
  }
}
</script>
<style scoped lang='less'>
/deep/ .el-tabs__item {
  width:150px;
  text-align: center;
  // background-color:#ccc ;
}
/deep/ .is-active{
  background-color:#409EFF;
  color: #fff;
}
.el-table{
overflow:visible !important;
}
.searchBox{
  margin-left: 10px;
}
.inpBox{
  margin: 10px 0 0 -55px;
  
}

 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.searchBtnBox{
  margin-top: 10px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
.tongJi{
  display: flex;
  margin-left:10px;
}
.tongJi_item{
  margin-right: 20px;
}
.tongJi_item span{
  color: red;
}
.topRadio{
  margin-left:10px;
  margin-bottom: 5px;
  padding-top:10px;
  padding-bottom: 10px;
  border-bottom:1px solid #ccc;
}
</style>
